import { Input, Output, Component, OnInit, EventEmitter, forwardRef, ElementRef } from '@angular/core';
import { NgbDateStruct, NgbTimepicker, NgbTimeStruct, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Statique } from '../../utils/statique';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, FormControl } from '@angular/forms';

const now = new Date();

@Component({
    selector: 'app-datetime-picker',
    host: {
        '(document:click)': 'onClick($event)',
    },
    templateUrl: './datetime-picker.component.html',
    styleUrls: ['./datetime-picker.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatetimePickerComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DatetimePickerComponent),
            multi: true,
        }
    ]
})
export class DatetimePickerComponent implements OnInit, ControlValueAccessor, Validator {

    @Input() name?: string;
    @Input() disabled?: boolean;
    @Input() required?: any;
    @Input() _ngClass?: string;
    @Input() placeholder?: string;
    @Input() timepicker?: boolean;
    @Input()
    get date(): any {
        return this.dateValue;
    }

    dynamicId;
    timepickerToggleOn: boolean;

    @Output() dateChange = new EventEmitter();
    set date(val: any) {

        if (typeof val === "string")
            this.dateValue = Statique.stringToDate(val);
        else if (val && (typeof val === "object" || typeof val === "number"))
            this.dateValue = new Date(val);

        if (!val || !this.dateValue) {
            this.dateValue = null;
            this.formattedDate = null;
            this.formattedTime = null;
        }
        else {
            this.formattedDate = Statique.formatDateToStructure(this.dateValue);
            this.formattedTime = Statique.formatTimeToStructure(this.dateValue);
            this.textFormattedTime = Statique.lpad(this.formattedTime.hour) + ":" + Statique.lpad(this.formattedTime.minute);
        }

        this.propagateChange(this.dateValue);
    }

    time: any;
    dateValue: Date;
    formattedDate: NgbDateStruct;
    formattedTime: NgbTimeStruct;
    textFormattedTime: string;

    constructor(private elementRef: ElementRef) {
        this.timepickerToggleOn = false;
    }

    ngOnInit() {
        if (typeof this.name === "undefined")
            this.name = "datetime-" + (new Date()).toTimeString();
        if (typeof this.disabled === "undefined")
            this.disabled = false;
        if (typeof this.required === "undefined")
            this.required = false;
        if (typeof this.placeholder === "undefined")
            this.placeholder = "dd/mm/yyyy";
        if (typeof this.timepicker === "undefined")
            this.timepicker = false;
        if (typeof this._ngClass === "undefined")
            this._ngClass = "";
    }

    dateChangeHandler(fd: NgbDateStruct) {
        let dt = Statique.fromDatePicker(fd);
        this.date = Statique.formatDateTime(dt, this.formattedTime);
        if (!this.formattedTime) {
            this.formattedTime = Statique.formatStrTimeToStructure(null);
            this.formattedTime.hour = 0;
            this.formattedTime.minute = 0;
            this.formattedTime.second = 0;
            this.textFormattedTime = "00:00";
        }
        // this.dateChange.emit(Statique.fromDatePicker(fd));
    }

    textTimeChangeHandler(textTime: string) {
        this.formattedTime = Statique.formatStrTimeToStructure(textTime);
        if (this.date)
            this.date = Statique.formatDateTime(this.date, this.formattedTime);
        // this.dateChange.emit(Statique.fromDatePicker(fd));
    }

    timeChangeHandler(ft: NgbTimeStruct) {
        if (ft) {
            this.formattedTime = ft;
            this.textFormattedTime = Statique.lpad(ft.hour) + ":" + Statique.lpad(ft.minute);
            if (this.date)
                this.date = Statique.formatDateTime(this.date, this.formattedTime);
            // this.dateChange.emit(Statique.fromDatePicker(fd));
        }
    }

    writeValue(value: any) {
        this.date = value;
    }

    propagateChange = (_: any) => { };
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched() { }
    public validate(c: FormControl) {
        return this.date || !this.required ? null : {
            jsonParseError: {
                valid: false,
            },
        };
    }

    public openDatepicker(id) {
        this.dynamicId = id;
    }
    onClick(event) {
        if (this.dynamicId == undefined) {
        }
        else if (!this.elementRef.nativeElement.contains(event.target)) {
            let self = this;
            setTimeout(function () {
                self.dynamicId.close();
            }, 10);
        }
    }
    // public selectToday() {
    //     let executed = false;
    //     return function () {
    //         if (!executed) {
    //             executed = true;
    //             this.formattedDate = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate()};
    //         }
    //     };
    // }



}



// WEBPACK FOOTER //
// ./src/app/shared/datetime-picker/datetime-picker.component.ts